<template>
    <div>
        <div class="col-lg-12" style="" v-if="coachingPlan" :class="{ loading: isLoading }">

            <div class="btn-group mb-2">
                <button type="button" class="btn btn-default btn-lg dropdown-toggle ml-0 pl-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Coaching Program: {{ coachingPlan.coaching_program.name }}
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <button
                        v-for="coachingProgram in availableCoachingPrograms"
                        v-bind:key="coachingProgram.id"
                        :disabled="coachingPlan.coaching_program_id == coachingProgram.id || !coachingPlanCanBeEdited"
                        class="dropdown-item"
                        type="button"
                        @click="changeCoachingProgram(coachingProgram)"
                    >{{coachingProgram.name}} <span v-if="coachingPlan.coaching_program_id == coachingProgram.id">(selected)</span></button>
                </div>
            </div>
            <div class="alert alert-info" v-if="coachingPlanIsApproved">
                This coaching plan was approved by {{ coachingPlan.approved_by.first_name }} {{ coachingPlan.approved_by.last_name }} on {{ coachingPlan.approved_at | moment("M/DD/YYYY hh:mm a")}}
            </div>
            <div v-if="coachingFileSets.length > 0">
                <div>Please choose a file set:</div>
                <select class="form-control mb-2" v-model="selectedCoachingFileSetId" :disabled="!coachingPlanCanBeEdited">
                    <option disabled value="">Please select one</option>
                    <option v-for="(fileset, index) in coachingFileSets" v-bind:key="index" v-text="fileset.name" :value="fileset.id"></option>
                </select>
            </div>

            <table class="table table-sm">
              <thead class="thead-light">
                <tr>
                  <!-- <th></th> -->
                  <th>Name</th>
                  <th>Status</th>
                  <th>Details</th>
                  <!-- <th>Send/Sent</th>
                  <th>Completed</th>
                  <th>Reviewed</th> -->
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="checkin in coachingPlan.checkins" v-bind:key="checkin.id">
                  <!-- <th>
                    <button @click="" class="btn btn-default"><i class="mdi chevron-down"></i></button>
                  </th> -->
                  <th>{{ checkin.coaching_program_checkin.name }}</th>
                  <td><checkin-status-badge :status="checkin.status"></checkin-status-badge></td>
                  <td>
                    <!-- <div>
                      Send on: Day {{ checkin.coaching_program_checkin.send_on_day }}
                    </div> -->
                    <div v-if="checkin.sent_at">
                      <span>Sent:</span>
                      <span>{{checkin.sent_at | moment('M/D/Y') }}</span>
                      <span class="small">{{checkin.sent_at | moment('HH:mm:ss a') }}</span>
                    </div>
                    <div v-else-if="checkin.send_on_date">
                      <span>Will send on:</span>
                      <span class="text-muted">{{checkin.send_on_date | moment('M/D/Y') }}</span>
                    </div>
                    <div v-else>
                      <span>Will send:</span>
                      <span class="text-muted">{{checkin.coaching_program_checkin.send_on_day }} days after plan is approved</span>
                    </div>
                    <div v-if="isCompleted(checkin)">
                      <span>Completed:</span>
                      <span>{{checkin.completed_at | moment('M/D/Y') }}</span>
                      <span class="small">{{checkin.completed_at | moment('HH:mm:ss a') }}</span>
                    </div>
                    <div v-if="isReviewed(checkin)">
                      <span>Reviewed:</span>
                      <span>{{checkin.reviewed_at | moment('M/D/Y') }}</span>
                      <span class="small">{{checkin.reviewed_at | moment('HH:mm:ss a') }}</span>
                      <span v-if="checkin.reviewed_by">by {{ checkin.reviewed_by.name }}</span>
                    </div>
                  </td>
                  <td>
                    <button v-if="!isCompleted(checkin)" @click="previewCheckinEmail(checkin)" class="btn btn-sm btn-secondary"><i class="mdi mdi-email-outline"></i> Preview/Send</button>
                    <button v-if="isPendingReview(checkin) || isReviewed(checkin)" @click="openCheckinFeedbackModal(checkin)" class="btn btn-sm btn-primary"><i class="mdi mdi-message"></i> Review</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center">
                <button class="btn btn-secondary mt-2" :disabled="!coachingPlanCanBeApproved" @click.prevent="approveCoachingPlan()">Save & Approve Coaching Plan</button>
            </div>
        </div>
        <checkin-preview-modal
          :show="showPreviewModal"
          :checkin="previewCheckin"
          @close="previewModalClosed()"
          @checkinEmailSent="checkinEmailSent"
        ></checkin-preview-modal>
        <checkin-feedback-modal
          :show="showCheckinFeedbackModal"
          :checkin_id="checkinToSendFeedbackId"
          @close="checkinFeedbackModalClosed()"
          @checkinUpdated="feedbackSubmitted"
        ></checkin-feedback-modal>
    </div>
</template>
<script>
export default {
    props: [
      'initialCoachingPlan'
    ],
    data() {
      return {
        coachingPlan: this.initialCoachingPlan,
        coachingFileSets: [],
        selectedCoachingFileSetId: this.initialCoachingPlan.coaching_file_set_id,
        previewCheckin: null,
        showPreviewModal: false,
        showCheckinFeedbackModal: false,
        checkinToSendFeedback: null,
        showModal: false,
        isLoading: false
      }
    },
    mounted() {
      this.getAvailableCoachingFileSets();
    },
    computed: {
      checkinToSendFeedbackId: function() {
        return this.checkinToSendFeedback?.id ?? null;
      },
      coachingPlanIsApproved: function() {
        return this.coachingPlan.approved_at != null;
      },
      availableCoachingPrograms: function() {
        return this.$root.availableCoachingPrograms;
      },
      requiresCoachingFileSet: function() {
        return this.coachingPlan.coaching_program.file_set_required === 1;
      },
      hasCoachingFileSet: function() {
        return this.selectedCoachingFileSetId != null;
      },
      requiresCheckins: function() {
        return this.coachingPlan.coaching_program.checkins_required === 1;
      },
      hasCheckins: function() {
        return this.coachingPlan.checkins.length > 0;
      },
      coachingPlanCanBeApproved: function() {
        //What do we need? Checkins I guess? Maybe at least 1 template attached? Should depend on program.
        return this.coachingPlanCanBeEdited
          && (!this.requiresCheckins || this.hasCheckins)
          && (!this.requiresCoachingFileSet || this.hasCoachingFileSet);
      },
      coachingPlanCanBeEdited: function() {
        return !this.$root.planIsApproved;
      },
    },
    methods: {
      isCompleted: function (checkin) {
        if (checkin.completed_at) {
          return true;
        }
        return false;
      },
      isAwaitingResponse: function (checkin) {
        if (!checkin.completed_at && checkin.sent_at) {
          return true;
        }
        return false;
      },
      isPending: function (checkin) {
        if (!checkin.completed_at && !checkin.sent_at) {
          return true;
        }
        return false;
      },
      isPendingReview: function (checkin) {
        return checkin.status == 'pending_review';
      },
      isReviewed: function (checkin) {
        return checkin.status == 'reviewed';
      },
      changeCoachingProgram: function(coachingProgram) {
        var _this = this;
        _this.isLoading = true;

        axios.put('/api/coaching_plans/' + _this.coachingPlan.id,{
          'coaching_program_id': coachingProgram.id
        }).then(function (response) {
          _this.coachingPlan = response.data.data;
          // _this.getAvailableCoachingFileSets();
          Promise.all([_this.getAvailableCoachingFileSets()])
            .then(function (results) {
              _this.isLoading = false;
            });
        });
      },
      approveCoachingPlan: function() {
        var _this = this;
        _this.isLoading = true;

        axios.put('/api/coaching_plans/' + _this.coachingPlan.id, {
          approve: true,
          coaching_file_set_id: _this.selectedCoachingFileSetId,
        }).then(function (response) {
          _this.coachingPlan = response.data.data;
          _this.isLoading = false;
          _this.$toasted.success("Coaching Plan Approved!")
          _this.$emit('coachingplan-updated', _this.coachingPlan);
        })
        .catch(e => {
          _this.$toasted.error(e.response.data.message);
          _this.isLoading = false;
        })
      },
      mergeCheckinData: function(checkinData) {
        // update local
        this.coachingPlan.checkins = this.coachingPlan.checkins.map(function(checkin) {
          if (checkin.id == checkinData.id) {
            return mergeObj(checkin, checkinData);
          }
          return checkin;
        });
      },
      previewCheckinEmail: function(checkin) {
        this.previewCheckin = checkin;
        this.showPreviewModal=true;
      },
      checkinEmailSent: function(checkin) {
        this.mergeCheckinData(checkin);
        this.previewModalClosed();
      },
      previewModalClosed: function() {
        this.previewCheckin = null;
        this.showPreviewModal = false;
      },
      feedbackSubmitted: function(checkin) {
        console.log("Feedback submitted for checkin! " + checkin.id);
        // update it.
        this.mergeCheckinData(checkin);
        this.checkinFeedbackModalClosed();
      },
      openCheckinFeedbackModal: function(checkin) {
        this.showCheckinFeedbackModal = true;
        this.checkinToSendFeedback = checkin;
      },
      checkinFeedbackModalClosed: function() {
        this.showCheckinFeedbackModal = false;
        this.checkinToSendFeedback = null;
      },
      getAvailableCoachingFileSets: async function () {
        var _this = this;
        _this.isLoading = true;
        // axios.get('/api/coaching_file_sets').then(function (response) {
        await axios.get('/api/coaching_programs/'+this.coachingPlan.coaching_program_id+'/file_sets')
          .then(function (response) {
            _this.coachingFileSets = response.data.data;
            // If selectedCoachingFileSetId Not in this set, deselect it.
            if (_this.coachingFileSets.findIndex(obj => obj.id == _this.selectedCoachingFileSetId) < 0) {
                _this.selectedCoachingFileSetId = null;
            }
          }).finally(function(){
              _this.isLoading = false;
          });
      },
  },
  watch: {
    initialCoachingPlan: function (newVal,oldVal) {
      Vue.set(this, 'coachingPlan', newVal);
      // Vue.set(this, 'selectedWorkoutFileSet', this.initialWorkoutPlan.workout_file_set);
    }
  }
}
</script>
